import Dexie from 'dexie'

export const db = new Dexie('MerchClientDB')

db.version(1).stores({
  // Справочники — кэшируются когда онлайн
  auth_cache: 'id, token, expiresAt',
  projects:  'id, name, cachedAt',
  networks:  'id, name, projectId, cachedAt',
  points:    'id, name, networkId, cachedAt',
  products:  'id, name, pointId, cachedAt',

  // Рабочие данные — создаются офлайн
  reports: '++id, serverId, productId, pointId, networkId, projectId, synced, updatedAt',
  photos:  '++id, reportId, serverId, synced',
})

export default db